import React from 'react'
import { Link } from 'react-router-dom'

import DeleteIcon from 'Assets/Images/icons/delete'

export const LinkDeleteUnstyled = props => (
  <div className={props.className} onClick={props.onClickHandler}>
    <DeleteIcon />
    <Link to={props.to || ''} />
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/LinkDelete/unstyled.js